const AUTH0_MINIMAL_SCOPE = ['openid', 'profile'];
const FARMER_SCOPE = [
    ...AUTH0_MINIMAL_SCOPE,
    'profiles:manage:user',
    'orders:read:membership',
    'pickup-points:read:cooperative',
    'articles:read:cooperative',
    'offers:read',
    'offers:read:membership',
    'discounts:read:user',
    'stocks:read:variant',
    'stocks:read:seller',
    'events:write:products-viewed',
    'logistic-offers:read:seller',
    'analytics:write:members',
    'payment-due-dates:read:cooperative',
    'quotas:read:cooperative',
    'shipping-addresses:read:profile',
    'contents:read:cooperative',
    'purchase-orders:manage:user',
    'logistic-offers:read:seller',
    'memberships:read:cooperative',
];
const TECH_SCOPES = [
    'openid',
    'profile',
    'lists:manage:user',
    'memberships:read:profile',
    'offers:read',
    'offers:read:cooperative',
    'orders:read:members',
    'pickup-points:read:cooperative',
    'users:read:members',
    'discounts:read:user',
    'stocks:read:variant',
    'payment-due-dates:read:cooperative',
    'quotas:read:cooperative',
    'shipping-addresses:read:profile',
    'reporting:read:ca',
    'contents:read:cooperative',
    'shopping-lists:manage',
    'events:read:products-viewed',
    'logistic-offers:read:seller',
    'stocks:read:seller',
    'analytics:write:members',
];
export function getAuthConfigFor(frontName) {
    switch (frontName) {
        case 'agri':
            return FARMER_SCOPE;
        case 'tech':
            return TECH_SCOPES;
        default:
            return [];
    }
}
//# sourceMappingURL=config.js.map